import React from 'react';

export default function PrivacyTermsContent() {
  return (
    <>
      <section>
        <h3>Key Privacy &amp; Security Commitments</h3>
        <p>At PartyDecider:</p>
        <ul>
          <li>We collect only the data needed to run PartyDecider and improve the experience.</li>
          <li>We never sell your personal data to third parties.</li>
          <li>All connections use HTTPS encryption.</li>
        </ul>
      </section>

      <section>
        <h3>Privacy Policy</h3>
        <p>
          PartyDecider respects your privacy. We collect only the minimal information necessary to provide our services
          and improve the experience:
        </p>
        <ul>
          <li>Authentication data (Google account email and profile) when you sign in</li>
          <li>Event and plan data you create</li>
          <li>Basic usage analytics to improve our service</li>
        </ul>
        <p>
          We do not sell your data to third parties. Your event data is stored securely and only shared with people you
          invite.
        </p>
          <p>
            <strong>Google Analytics:</strong> We use Google Analytics 4 to collect anonymous usage data and understand how PartyDecider is used. This helps us improve the service. Google Analytics operates in privacy-enhanced measurement and consent mode, respecting your privacy choices. You can opt out of Google Analytics tracking by using <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google’s opt-out browser add-on</a> or adjusting your browser settings.
          </p>
      </section>

      <section>
        <h3>Terms of Service</h3>
        <p>By using PartyDecider, you agree to:</p>
        <ul>
          <li>Use the service for lawful purposes only</li>
          <li>Not share offensive, harmful, or inappropriate content</li>
          <li>Respect other users&apos; privacy and event data</li>
          <li>Understand that we provide the service &quot;as is&quot; without warranties</li>
        </ul>
        <p>
          We reserve the right to remove content or suspend accounts that violate these terms.
        </p>
      </section>

      <section>
        <h3>Contact</h3>
        <p>
          For questions or concerns, please contact us through the About page or at support@partydecider.com
        </p>
      </section>
    </>
  );
}
